// Renders em dashes in the body font; the display face draws them as a faint hairline.
export const DashTitle = ({ text }) =>
  text.split("\u2014").map((part, i) => (
    <span key={i}>
      {i > 0 && <span className="font-serif not-italic">&mdash;</span>}
      {part}
    </span>
  ));
